import { pathOr } from 'ramda';

import { IState } from '../../store';

export const getIsFromLeadFactory = (state: IState): boolean => {
  return pathOr(false, ['offerData', 'offer', 'isFromLeadFactory'], state);
};
